// extracted by mini-css-extract-plugin
export default {"navbarLogo":"NavbarLogo_navbarLogo__m2bMU","logoContainer":"NavbarLogo_logoContainer__0WwcJ"};